define('modules/lists/modals/modals.controller',[
    "client"
], function(
    Prospector)
{
    Prospector.module("ModalApp.List", function(List, Prospector, Backbone, Marionette, $, _){
        List.Controller = {
            showEditContact: function(options) {
                require(["modules/lists/modals/views/edit.contact.view"], function(EditContactView){
                    var ecv = new EditContactView(options);
                    Prospector.trigger('showModal', {view: ecv});
                });
            },
            showEditContacts: function(options) {
                require(["modules/lists/modals/views/edit.contacts.view"], function(EditContactsView){
                    var ecv = new EditContactsView(options);
                    Prospector.trigger('showModal', {view: ecv});
                });
            },
            showDeleteList: function(options) {
                require(["modules/lists/modals/views/delete.list.view"], function(DeleteListView){
                    var dlv = new DeleteListView(options);
                    Prospector.trigger('showModal', {view: dlv});
                });
            },
            showDeleteContactModal: function(options) {
                require(["modules/lists/modals/views/delete.contact.from.list.view"], function(DeleteContactFromListView){
                    var dlv = new DeleteContactFromListView(options);
                    Prospector.trigger('showModal', {view: dlv});
                });
            },
            showCreatePerson: function(options) {
                require(["modules/lists/modals/views/create.person.view"], function(CreatePersonView){
                    var cpv = new CreatePersonView(options);
                    Prospector.trigger('showModal', {view: cpv});
                });
            },
            showCreateCompany: function(options) {
                require(["modules/lists/modals/views/create.company.view"], function(CreateCompanyView){
                    var cpv = new CreateCompanyView(options);
                    Prospector.trigger('showModal', {view: cpv});
                });
            },
            showListQuota: function(options) {
                require(["modules/lists/modals/views/list.quota.view"], function(ListQuotaView){
                    var lqv = new ListQuotaView(options);
                    Prospector.trigger('showModal', {view: lqv});
                });
            },
            showListQuota2: function(options) {
                require(["modules/lists/modals/views/list.quota2.view"], function(ListQuotaView2){
                    var lqv = new ListQuotaView2(options);
                    Prospector.trigger('showModal', {view: lqv});
                });
            }


        }
    });
    return Prospector.ModalApp.List.Controller;
});
